import React, { useContext, useState, useMemo } from 'react';
import { FaUser, FaCog, FaPlus, FaSignOutAlt } from 'react-icons/fa';
import { HiOutlineTicket } from 'react-icons/hi';
import { RiDashboardLine } from 'react-icons/ri';
import { PanelContext } from '../../../app/providers/PanelContext';
import { AuthContext } from '../../../app/providers/AuthContext';
import LogoutModal from './LogoutModal';
import DevelopmentModal from './left-panel-contents/DevelopmentModal';

const LeftPanelToolbar = () => {
  const { selectedPanel, setSelectedPanel } = useContext(PanelContext);
  const { logout } = useContext(AuthContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDevelopmentMode, setIsDevelopmentMode] = useState(false);

  const handleLogoutClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleLogoutConfirm = () => {
    setIsModalOpen(false);
    logout();
  };

  const iconClasses = (panelName) =>
    `relative flex items-center justify-center transition-all duration-200 ease-out ${
      selectedPanel === panelName ? 'text-blue-200 scale-105' : 'text-slate-400 hover:text-blue-200'
    }`;

  const icons = useMemo(
    () => [
      { icon: HiOutlineTicket, panel: 'flow', label: 'Ticketlar' },
      { icon: RiDashboardLine, panel: 'home', label: 'Dashboard' },
      { icon: FaPlus, panel: 'newTicket', label: 'Yeni Ticket' },
    ],
    [],
  );

  const bottomIcons = useMemo(
    () => [
      { icon: FaUser, panel: 'profile', label: 'Profil' },
      { icon: FaCog, panel: 'settings', label: 'Ayarlar' },
    ],
    [],
  );

  return (
    <div className="flex h-full w-full flex-col items-center justify-between py-6">
      <div className="flex flex-col items-center space-y-5">
        {icons.map(({ icon: Icon, panel, label }) => (
          <button
            key={panel}
            onClick={() => setSelectedPanel(panel)}
            className="relative flex items-center justify-center"
            title={label}
          >
            <span
              className={`absolute inset-0 rounded-full bg-blue-500/10 blur-md transition-all duration-200 ease-out ${
                selectedPanel === panel ? 'opacity-100 scale-125' : 'opacity-0 scale-100'
              }`}
            />
            <Icon className={`${iconClasses(panel)} text-2xl`} />
          </button>
        ))}
      </div>

      <div className="flex flex-col items-center space-y-5">
        {bottomIcons.map(({ icon: Icon, panel, label }) => (
          <button
            key={panel}
            onClick={() => setSelectedPanel(panel)}
            className="relative flex items-center justify-center"
            title={label}
          >
            <span
              className={`absolute inset-0 rounded-full bg-blue-500/10 blur-md transition-all duration-200 ease-out ${
                selectedPanel === panel ? 'opacity-100 scale-125' : 'opacity-0 scale-100'
              }`}
            />
            <Icon className={`${iconClasses(panel)} text-2xl`} />
          </button>
        ))}
        <button
          onClick={handleLogoutClick}
          className="relative flex items-center justify-center"
          title="Çıkış Yap"
        >
          <span className="absolute inset-0 rounded-full bg-red-500/10 blur-md transition-all duration-200 ease-out opacity-0" />
          <FaSignOutAlt className="text-2xl text-slate-400 transition-colors duration-200 hover:text-red-400" />
        </button>
      </div>

      {isModalOpen && (
        <LogoutModal onClose={handleModalClose} onConfirm={handleLogoutConfirm} />
      )}

      {isDevelopmentMode && (
        <DevelopmentModal isOpen={isDevelopmentMode} onClose={() => setIsDevelopmentMode(false)} />
      )}
    </div>
  );
};

export default LeftPanelToolbar;
